
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galleri",
      function () {
        return require("private-next-pages/galleri/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/galleri"])
      });
    }
  